import { render, staticRenderFns } from "./DataViewSidebarActivities.vue?vue&type=template&id=04a9a352&scoped=true&"
import script from "./DataViewSidebarActivities.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarActivities.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarActivities.vue?vue&type=style&index=0&id=04a9a352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9a352",
  null
  
)

export default component.exports